module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"redirect_message":"%{second}秒後に移動します"}}')
  delete Component.options._Ctor
}
